const BaseError = require('make-error').BaseError;

class AntennaConfigurationError extends BaseError {
    constructor(errorMessage='Cannot provision more antennas than the maximum number of antennas allowed') {
        super(errorMessage);
    }
}

module.exports = AntennaConfigurationError;